import React from 'react';
import PropTypes from 'prop-types';
import useS3PresignedUrl from 'hooks/useS3PresignedUrl';

const S3Image = ({ bucket, objectKey, alt, className, style, onClick }) => {
  const url = useS3PresignedUrl(bucket, objectKey);

  if (!url) return null;

  return (
    <img
      src={url}
      alt={alt || ''}
      className={className}
      style={style}
      onClick={onClick}
    />
  );
};

S3Image.propTypes = {
  bucket: PropTypes.string,
  objectKey: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};

export default S3Image;
